import React, {useState} from 'react';
import PropTypes from 'prop-types';
import CVEditExperienceType from './edit-experience-type/edit-experience-type';

import {Header, Desc, DescriptionEdit, TitleEditWrapper} from './cv-edit-styles';
import {EducationFormElements, HonoraryOrVolunteerElements, LanguageFormElements, ProjectFormElements, WorkExperiencesFormElements} from './form-elements';
import {TopBar} from '../cv-components';
import {MainHeader, ContentWrapper} from '../cv-styles';
import {StyledInput} from '@components/form-input/form-input-styles';
import {i18n} from '@src/i18n';


export const CVEdit = ({
  initialExperienceData,
  initialDescription,
  initialTitle,
  cvID,
  profile,
  onSave,
  onSaved,
}) => {
  const [experienceData, setExperienceData] = useState(initialExperienceData);

  const [description, setDescription] = useState(initialDescription);
  const [title, setTitle] = useState(initialTitle);

  const updateData = (kind, changedData) => {
    const copyOfStoredExperienceData = experienceData;

    copyOfStoredExperienceData[kind] = changedData;
    setExperienceData(copyOfStoredExperienceData);
  };

  return (
    <>

      <TopBar
        manageMode="edit"
        title={title}
        onClickEditSave={() => onSave({
          description,
          experienceData,
          title,
        })}
      />

      <ContentWrapper>
        <MainHeader>
          {profile.data.fullname}
        </MainHeader>

        <Header>
          {i18n('cv.form-elements.name')}
        </Header>
        <TitleEditWrapper>
          <StyledInput
            name="cv-name"
            label=""
            input={{value: title}}
            onChange={evt => setTitle(evt.target.value)}
            value={title}
          />

        </TitleEditWrapper>

        <Header>{i18n('globals.about')}</Header>
        <Desc>{i18n('cv.form-elements.description')}</Desc>
        <DescriptionEdit
          key="description"
          rows="8"
          cols="80"
          value={description}
          onChange={evt => {
            setDescription(evt.target.value);
          }}
        />
        <CVEditExperienceType
          title={i18n('cv.experience-kind-headers.work')}
          experienceKind="work"
          description="Registrer alle dine relevante jobberfaringer. Det er opp til deg selv å vurdere hva som er relevant eller ikke. Har du mange år i arbeidslivet, ta med det viktigste og det som er relevant ift. jobben du søker. Husk også å unngå “hull i CV-en” (perioder uten noen oppføringer i CV-en). Har du det, har du kanskje utelukket noe som bør være med."
          addNewBtnTxt={i18n('cv.add-new-of-kind.work')}
          onAlteredData={updateData}
          manageExperienceFormElementsComponent={
          WorkExperiencesFormElements
        }
          initialExperienceData={experienceData.work || []}
        />

        <CVEditExperienceType
          title={i18n('cv.experience-kind-headers.education')}
          description="Liste over din formelle utdanning."
          experienceKind="education"
          addNewBtnTxt={i18n('cv.add-new-of-kind.education')}
          onAlteredData={updateData}
          manageExperienceFormElementsComponent={EducationFormElements}
          initialExperienceData={experienceData.education || []}
        />

        <CVEditExperienceType
          title={i18n('cv.experience-kind-headers.project')}
          experienceKind="project"
          description="Relevante prosjekter du ønker å fremheve."
          addNewBtnTxt={i18n('cv.add-new-of-kind.project')}
          onAlteredData={updateData}
          manageExperienceFormElementsComponent={ProjectFormElements}
          initialExperienceData={experienceData.project || []}
        />

        <CVEditExperienceType
          title={i18n('cv.experience-kind-headers.elected')}
          experienceKind="elected"
          description="Frivillig arbeid og tillitsverv du har htt."
          addNewBtnTxt={i18n('cv.add-new-of-kind.elected')}
          onAlteredData={updateData}
          manageExperienceFormElementsComponent={
          HonoraryOrVolunteerElements
        }
          initialExperienceData={experienceData.elected || []}
        />

        <CVEditExperienceType
          title={i18n('cv.experience-kind-headers.language')}
          description="Dine skriftlige og muntlige språkferdigheter."
          addNewBtnTxt={i18n('cv.add-new-of-kind.language')}
          experienceKind="language"
          onAlteredData={updateData}
          manageExperienceFormElementsComponent={LanguageFormElements}
          initialExperienceData={experienceData.language || []}
        />
      </ContentWrapper>
    </>
  );
};

CVEdit.propTypes = {
  initialExperienceData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  initialDescription: PropTypes.string.isRequired,
  profileEditCV: PropTypes.func.isRequired,
  cvID: PropTypes.number.isRequired,
  onSave: PropTypes.func.isRequired,
  onSaved: PropTypes.func.isRequired,
};

CVEdit.defaultProps = {};


export default CVEdit;
